module.exports = __webpack_public_path__ + "static/media/ggsf_logo.f525f7e7.png";